import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";

configure({
  generateMessage: localize("fr", {
    messages: {
      required: "Veuillez saisir une valeur pour le champ: {field}.",
      email: "Le format de l'adresse e-mail renseignée est incorrect.",
      password:
        "Le mot de passe n'est pas assez sécurisé (min. 1 chiffre, symbole, minuscule, majuscule ainsi que 8 caractères minimum).",
      textOnly:
        "Seulement les caractères alphabétiques (a-zA-Z) ainsi que diacritiques (à-Ÿ) sont autorisés.",
      min: "La saisie ne comprend pas assez de caractères (Min. 0:{length} caractères).",
      max: "Limite de caractères dépassées (Max. 0:{length} caractères).",
      postalCode:
        "Le code postal que vous avez saisi est incorrect (Ex: 75000).",
      match:
        "Les deux champs ne correspondent pas, veuillez vérifiez votre saisie.",
      is_not:
        "La saisie ne peut être identique, veuillez en renseigner une nouvelle.",
      not_included: "Cette valeur est déjà présente dans la liste.",
      vat: "Le numéro de TVA n'est pas au bon format, veuillez vérifiez votre saisie.",
    },
  }),
});
